import { useQuery } from "@tanstack/react-query";
import { fetchGetQuery } from "../api";

// API call to get project details for Splosno section
export function useGetNazivAndStatusProjekta(id) {
  const url = `Projekti/${id}/NazivInStatusV2`;
  return useQuery({
    queryKey: ["project-status-naziv", id],
    queryFn: async () => {
      return fetchGetQuery(url);
    },
    retry: false, // Do not retry on failure, handle errors in the component
  });
}
